/* Product form — variant selection + AJAX add-to-cart that opens the drawer. */

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
    this.form = this.closest('product-form') || document;
    this.addEventListener('change', () => this.onChange());
  }

  onChange() {
    const selected = this.selectedOptions();
    const variant = this.variants.find((v) =>
      v.options.every((opt, i) => opt === selected[i])
    );
    this.updateVariant(variant);
  }

  selectedOptions() {
    const groups = this.querySelectorAll('[data-option-index]');
    return Array.from(groups).map((group) => {
      const checked = group.querySelector('input:checked');
      if (checked) return checked.value;
      const select = group.querySelector('select');
      return select ? select.value : null;
    });
  }

  updateVariant(variant) {
    const root = this.closest('product-form');
    if (!variant) {
      this.toggleAvailability(root, false, true);
      return;
    }

    const idInput = root.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    if (variant.url) history.replaceState({}, '', variant.url);
    else {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    // Shopify varyant JSON'unda price_html yoktur; biçimlenmiş fiyatlar
    // Liquid tarafında üretilip price_formatted / compare_formatted ile gelir.
    const priceMarkup = this.priceHtml(variant);
    const priceEl = root.querySelector('[data-price]');
    if (priceEl && priceMarkup) priceEl.innerHTML = priceMarkup;

    const stickyPriceEl = document.querySelector('[data-sticky-price]');
    if (stickyPriceEl && priceMarkup) stickyPriceEl.innerHTML = priceMarkup;

    this.querySelectorAll('[data-option-index]').forEach((group, i) => {
      const el = group.querySelector('[data-selected-value]');
      if (el) el.textContent = variant.options[i] || '';
    });

    if (variant.featured_media_id) {
      document.dispatchEvent(new CustomEvent('variant:media', { detail: { mediaId: variant.featured_media_id } }));
    }

    // Teklif formu gibi varyanta bağlı alanların güncellenmesi için
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));

    this.toggleAvailability(root, variant.available, false);
  }

  /* snippets/product-price.liquid ile aynı yapıyı üretir. */
  priceHtml(variant) {
    if (!variant.price_formatted) return '';
    const onSale = variant.compare_at_price > variant.price && variant.compare_formatted;
    return (
      '<span class="price' + (onSale ? ' price--on-sale' : '') + '">' +
        '<span class="price__current">' + variant.price_formatted + '</span>' +
        (onSale ? '<s class="price__compare">' + variant.compare_formatted + '</s>' : '') +
      '</span>'
    );
  }

  toggleAvailability(root, available, soldOrUnavailable) {
    const btn = root.querySelector('[data-add-to-cart]');
    const label = btn ? btn.querySelector('[data-atc-label]') : null;
    if (!btn) return;

    const stickyBtn = document.querySelector('[data-sticky-atc-btn]');

    if (!available) {
      btn.setAttribute('disabled', '');
      if (label) label.textContent = btn.dataset.soldOut || 'Tükendi';
      if (stickyBtn) {
        stickyBtn.setAttribute('disabled', '');
        stickyBtn.textContent = stickyBtn.dataset.soldOut || 'Tükendi';
      }
    } else {
      btn.removeAttribute('disabled');
      if (label) label.textContent = btn.dataset.addLabel || 'Sepete ekle';
      if (stickyBtn) {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.textContent = stickyBtn.dataset.addLabel || 'Sepete ekle';
      }
    }
  }
}
customElements.define('variant-selector', VariantSelector);

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-add-to-cart]');
    if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

    if (this.button) {
      const stickyBar = document.querySelector('[data-sticky-atc-bar]');
      if (stickyBar) {
        const observer = new IntersectionObserver(
          ([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting),
          { threshold: 0 }
        );
        observer.observe(this.button);
      }
    }
  }

  async onSubmit(e) {
    e.preventDefault();
    if (this.button.hasAttribute('disabled')) return;
    this.button.classList.add('is-loading');

    const formData = new FormData(this.form);
    formData.append('sections', 'cart-drawer-contents');

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        this.showError(data.description || data.message);
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer) await drawer.refresh(true);
    } catch (err) {
      console.error('Add to cart failed', err);
    } finally {
      this.button.classList.remove('is-loading');
    }
  }

  showError(message) {
    let el = this.querySelector('[data-form-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }
}
customElements.define('product-form', ProductForm);
